import { useEffect, useState } from "react";

// État d'une liste (filtre, tri) gardé pour la session de l'onglet :
// il survit au changement de page et au rechargement, pas à un nouvel onglet
const STORAGE_PREFIX = "liste:";

function readStored<T>(key: string, initial: T): T {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_PREFIX + key);
    return stored === null ? initial : JSON.parse(stored);
  } catch {
    return initial;
  }
}

export function useListState<T>(key: string, initial: T) {
  const [value, setValue] = useState<T>(() => readStored(key, initial));

  useEffect(() => {
    try {
      window.sessionStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(value));
    } catch {
      // Stockage indisponible (navigation privée, quota) : l'état reste en mémoire
    }
  }, [key, value]);

  return [value, setValue] as const;
}
